import { Breadcrumb, Layout, Spin, Table, Typography } from 'antd';
import React, { ReactElement, useEffect } from 'react';
import { ColumnsType } from 'antd/lib/table';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Dispatch } from 'redux';
import ILoan from '~Api/Loan/ILoan';
import { IDictionary } from '~utilities/IDictionary';
import { loansOtherRetainedFundsListAction } from './actions';
import './loans.less';
import { loansOtherRetainedFundsSelector } from './selectors';
import { currencyFormatter } from '~utilities/formatters';
import { warehousesListAction } from '~Warehouses/actions';
import IWarehouse from '~Api/Warehouse/IWarehouse';
import { warehousesSelector } from '~Warehouses/selectors';
import IWarehouseLoan from '~Api/Warehouse/IWarehouseLoan';
import dayjs from 'dayjs';
import { Helmet } from 'react-helmet';

export default function OtherRetainedFunds(): ReactElement {
    const loans: IDictionary<ILoan> = useSelector(loansOtherRetainedFundsSelector);
    const warehouses: IDictionary<IWarehouse> = useSelector(warehousesSelector);

    const dispatch: Dispatch = useDispatch();

    useEffect(() => {
        if (!loans) {
            dispatch(loansOtherRetainedFundsListAction());
        }
    }, [
        dispatch,
        loans,
    ]);

    useEffect(() => {
        if (!warehouses) {
            dispatch(warehousesListAction());
        }
    }, [
        dispatch,
        warehouses,
    ]);

    if (!loans || !warehouses) {
        return (
            <Layout className='loans'>
                <Helmet>
                    <title>Other Reatained Funds</title>
                </Helmet>
                <Breadcrumb className='breadcrumb'>
                    <Breadcrumb.Item>Home</Breadcrumb.Item>
                    <Breadcrumb.Item><Link to='/loans'>Loans</Link></Breadcrumb.Item>
                    <Breadcrumb.Item>Other Retained Funds</Breadcrumb.Item>
                </Breadcrumb>
                <Layout className='content-wrapper'>
                    <Layout.Content className='content'>
                        <Typography.Title level={2}>Other Retained Funds</Typography.Title>
                        <Spin />
                    </Layout.Content>
                </Layout>
            </Layout>
        );
    }

    const columns: ColumnsType<ILoan> = [
        {
            dataIndex: 'code',
            render: (code: string, loan: ILoan) => <Link to={`/loans/${loan.uuid}`}>{code}</Link>,
            title: 'Code',
            width: 150,
        },
        {
            dataIndex: 'name',
            render: (name: string, loan: ILoan) => <Link to={`/loans/${loan.uuid}`}>{name}</Link>,
            title: 'Name',
        },
        {
            dataIndex: 'amount',
            render: (amount: number) => currencyFormatter.format(amount),
            title: 'Loan Amount',
            width: 160,
        },
        {
            dataIndex: 'otherRetainedFunds',
            render: (otherRetainedFunds: number) => currencyFormatter.format(otherRetainedFunds),
            title: 'Other Retained Funds',
            width: 200,
        },
        {
            dataIndex: 'endDate',
            render: (endDate: string) => dayjs(endDate).format('Do MMMM YYYY'),
            title: 'End Date',
            width: 180,
        },
        {
            render: (loan: ILoan) => {
                const warehouseLoans: IWarehouseLoan[] = _.filter(loan.warehouseLoans, (warehouseLoan: IWarehouseLoan) => warehouseLoan.balancePrincipal < 0);

                return warehouses[warehouseLoans[0].warehouseUuid].name;
            },
            title: 'Warehouse',
            width: 230,
        },
    ];

    return (
        <Layout className='loans'>
            <Helmet>
                <title>Other Retained Funds</title>
            </Helmet>
            <Breadcrumb className='breadcrumb'>
                <Breadcrumb.Item>Home</Breadcrumb.Item>
                <Breadcrumb.Item><Link to='/loans'>Loans</Link></Breadcrumb.Item>
                <Breadcrumb.Item>Other Retained Funds</Breadcrumb.Item>
            </Breadcrumb>
            <Layout className='content-wrapper'>
                <Layout.Content className='content'>
                    <Typography.Title level={2}>Other Retained Funds</Typography.Title>
                    <Table
                        columns={columns}
                        dataSource={_.values(loans)}
                        pagination={false}
                        rowKey='uuid'
                        size='middle'
                    />
                </Layout.Content>
            </Layout>
        </Layout>
    );
}
